import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useCreateAgent } from '@/lib/api/agents';
import { ApiError } from '@/lib/api/client';
import { AgentForm } from '@/routes/agents/agent-form';

export function AgentNewPage() {
  const createAgent = useCreateAgent();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">New agent</h1>
        <p className="text-sm text-[var(--color-muted-foreground)]">
          Creating an agent saves its first version (v1) and makes it active.
        </p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Configuration</CardTitle>
          <CardDescription>The full spec is captured as version 1.</CardDescription>
        </CardHeader>
        <CardContent>
          <AgentForm
            submitting={createAgent.isPending}
            submitLabel="Create agent"
            error={error}
            onCancel={() => void navigate({ to: '/agents' })}
            onSubmit={(spec) => {
              setError(null);
              createAgent.mutate(spec, {
                onSuccess: (agent) =>
                  void navigate({ to: '/agents/$agentId', params: { agentId: agent.id } }),
                onError: (caught) =>
                  setError(
                    caught instanceof ApiError ? caught.message : 'Could not create the agent.',
                  ),
              });
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
}
